// REACT_APP_GTM_ID is a legacy variable name for the GA4 measurement ID.
// Never treat an Ads ID or an arbitrary GTM container as an analytics-only tag.
export function allowedGoogleTagIds(consent) {
  const analyticsId = process.env.REACT_APP_GTM_ID;
  const adsId = process.env.REACT_APP_GOOGLE_ADS_ID;
  return [
    consent.analytics && /^G-[A-Z0-9]+$/i.test(analyticsId || "") && analyticsId,
    consent.marketing && /^AW-\d+$/.test(adsId || "") && adsId,
  ].filter(Boolean);
}
